import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "LoginComponent"
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(1),
    width: '50% !important',
    ['@media only screen and (max-width: 812px)']: {
      width: '100% !important',
    },
  },
  title: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
    marginTop: '5px !important'
  },
  titlePrincipal: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 24,
  },
  subTitle: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 22,
  },
  margin: {
    margin: theme.spacing(1),
  },
  acceptBtn: {
    display: 'flex',
    width: '100% !important',
    justifyContent: 'center',
    // margin: theme.spacing(1),
    marginTop: '2% !important',
    fontWeight: 'bold',
  },
  cancelBtn: {
    display: 'flex',
    width: '100% !important',
    justifyContent: 'center',
    // margin: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    fontWeight: 'bold',
    border: `1px solid ${theme.palette.primary.main}`
  },
  topImage: {
    padding: theme.spacing(1),
  },
  captionRegister: {
    width: '100% !important',
  },
  wc100: {
    width: '100% !important',
    paddingTop: '5px !important',
    paddingLeft: '1px !important',
    paddingRight: '1px !important',
    paddingBottom: '1px !important',
  },
  pc12: {
    // padding: '12px !important',
    padding: '1px !important',
  },
  colContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  contentInfo: {
    marginTop: '7% !important',
    marginBottom: '10% !important',
  },
  containerResult: {
    display: 'grid !important',
    gridTemplateColumns: '70% 30%',
    height: '55vh !important',
    marginTop: 5,
    marginBottom: 5,
    // backgroundColor: theme.palette.background.paper,
    overflowY: 'auto',
    ['@media only screen and (max-width: 812px)']: {
      gridTemplateColumns: '50% 50%',
      height: '55vh !important',
    },
    // marginBottom: '5% !important'
  },
  leftColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    overflowY: 'none',
    justifyContent: 'flex-start !important',
  },
  rightColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-end !important',
    justifyContent: 'flex-start !important',
    overflowY: 'none',
  },
  helpIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: 5,
  },
  instructions: {
    marginTop: theme.spacing(2),
    textAlign: 'left',
    font: 19,
    letterSpacing: '0.53px',
    color: theme.palette.primary.color,
    opacity: 1
  },
}))
